<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [style]="{width: '800px'}"
  styleClass="p-fluid elimina-intervento-dialog"
  [showHeader]="false"
  (onHide)="hide()">

  <div class="dialog-container">
    <div class="dialog-header">
      <div class="header-content">
        <i class="pi pi-trash header-icon"></i>
        <h3>Conferma eliminazione dell'intervento</h3>
        <div class="code-badge" style="background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem;">
          <span class="code-value" style="font-weight: bold; color: #3a6e75;">{{ intervento?.scheda?.codice }}</span>
        </div>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        (click)="hide()">
      </button>
    </div>

    <div class="dialog-content">
      <div class="confirmation-content text-center" style="width: 95%; margin: 0 auto;">
        <div class="flex justify-content-center mb-3">
          <i class="pi pi-exclamation-triangle" style="font-size: 2rem; color: #f44336;"></i>
        </div>
        <span class="confirmation-message text-center" style="display: block;">
          Sei sicuro di voler eliminare l'intervento per l'anno {{ intervento?.richiesta?.anno }}?
          <br>
          Questa azione non può essere annullata.
        </span>
      </div>
    </div>

    <div class="dialog-footer">
      <button
        pButton
        pRipple
        label="Annulla"
        icon="pi pi-times"
        class="p-button-outlined p-button-secondary"
        (click)="hide()">
      </button>
      <button
        pButton
        pRipple
        label="Elimina"
        icon="pi pi-trash"
        class="p-button-danger"
        (click)="conferma()">
      </button>
    </div>
  </div>
</p-dialog>

<p-toast position="top-right"></p-toast>
